export const globalStyles = {
    mainMenuHeightSM: 56,
    subMenuHeightSM: 48,
  };